<template>
  <div>
    <Ibox v-if="data.status == 'success'" :back="true" :titulo="'Trabajadores de faena'">
      <b-col cols="12">
        <DataTable
            :loading="loading_tabla"
            :columns="columns"
            :rows="rows"
            clases="table-bordered table-hover table-condensed nowrap"
            :perPage="25">
          <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action' && utils.tienePermiso()">
            <a v-if="props.row.asociado==0" class="primary" v-on:click="putTrabajador(props.row.id_trabajador)" >Agregar</a>
            <a v-else style="color:red" v-on:click="putTrabajador(props.row.id_trabajador)" >Quitar</a>
          </span>
          </template>
        </DataTable>
      </b-col>
    </Ibox>
    <Ibox v-else :back="'true'" :titulo="'Trabajadores de faena'">
      <b-col cols="12">
        <h4>{{ data.msg }}</h4>
      </b-col>
    </Ibox>
    <b-modal size="lg" hide-footer ref="modal_agregar_trabajador" title="Agregar trabajador" :no-close-on-backdrop="true">
      <b-row>
        <FormGroup
          cols="6"
          label="Tipo de trabajador"
          :is_loading="loading">
        <v-select
            :clearable=false
            label="nombre_tipo"
            v-model="trabajador.id_tipo_trabajador"
            :options=options_tipo_trabajador
            :reduce="option=>option.id_tipo_trabajador"
            placeholder="Seleccione">
        </v-select>
      </FormGroup>
      <FormGroup
          cols="6"
          label="Trabajador"
          :is_loading=loading_trabajadores>
        <v-select
            label="trabajador"
            :clearable=false
            v-model="trabajador.id_trabajador"
            :reduce="id_trabajador=>id_trabajador.id_trabajador"
            :options=options_trabajador
            :placeholder="placeholder_trabajador">
        </v-select>
      </FormGroup>
      </b-row>
      <br>
      <b-row>
        <b-col cols="12" align="center">
          <b-button v-if="loading || loading_trabajadores" variant="primary" class="mr-1">
            <Loading :size="'1'" :text="'Cargando datos'"/>
          </b-button>
          <b-button v-else-if="putting" variant="primary"><Loading :size="'1'" :text="'Agregando'"/></b-button>
          <b-button v-else variant="primary" v-on:click="agregarTrabajador()">Agregar trabajador</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { utils } from "@/helpers";
import {userService} from "@/services";
import {faenaServices} from "@/services/faena.services";

export default {
  name: "Trabajadores",
  data(){
    return {
      data: {'status':'success'},
      loading:true,
      loading_trabajadores:false,
      loading_tabla:true,
      putting:false,
      utils,
      trabajador: {
        id_faena:this.$route.params.id_faena,
        id_cliente:userService.getUser().id_cliente,
        id_trabajador:null,
        id_tipo_trabajador:null
      },
      options_trabajador:[],
      options_tipo_trabajador: [],
      placeholder_trabajador:"Debe seleccionar tipo trabajador",
      columns:[
        {label: 'Empresa', field: 'nombre_empresa'},
        {label: 'Trabajador', field: 'trabajador'},
        {label: 'Rut', field: 'rut'},
        {label: 'Tipo trabajador', field: 'nombre_tipo'},
        {label: 'Acciones', field: 'action'}
      ],
      rows:[],
      json_meta: [
        [{
          "key": "charset",
          "value": "utf-8"
        }]
      ],
    }
  },
  mounted() {
    this.cargarFaena();
  },
  methods:{
    cargarFaena(){
      this.loading_tabla = true;
      let data = {"id_cliente":userService.getUser().id_cliente,"id_faena":this.$route.params.id_faena};

      faenaServices.getFaena(data).then(data=>{
        this.data = data;

        this.cargarDatos();
      });
    },
    cargarDatos(loading = true){
      this.loading_tabla = loading;
      let faena = {'id_cliente': userService.getUser().id_cliente,'id_faena':this.$route.params.id_faena}

      faenaServices.getTrabajadoresInFaena(faena).then(data=>{

        this.rows = data.data;

        this.loading_tabla = false;
      });
    },
    putTrabajador(id_trabajador) {
      let quitar = {"id_cliente":userService.getUser().id_cliente,"id_faena":this.$route.params.id_faena,"id_trabajador":id_trabajador};
        faenaServices.putTrabajadorFaena(quitar).then((data) => {

          if (data.status == "success") {
            this.cargarDatos(false);
          }else{
            utils.alerta(data);
          }
        });


    }
  }
}

</script>

<style scoped>

</style>